import { Label } from "@babackapp/ui/components/label";
import { useId } from "react";
import { Switch } from "@babackapp/ui/components/switch";

type ReturnCheckSingleBoxFieldProps = {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
};

export default function ReturnCheckSingleBoxField({ label, value, onChange }: ReturnCheckSingleBoxFieldProps) {
  const componentId= useId();

  return (
    <div className="flex justify-between">
      <div className="flex justify-start gap-2 align-text-top">
        <Switch id={componentId} onCheckedChange={onChange} checked={value} name="bypassStock" />
        <Label className="text-sm" htmlFor={componentId}>{label}</Label>
      </div>
    </div>
  );
}
